/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIPromptConfigViewModel } from "../types/TutorAIPromptConfigViewModel.ts";

export const tutorAIPromptConfigViewModelSchema = z.object({
  content: z
    .string()
    .describe(
      "Conteúdo do prompt configurado (persona ou memória). Null quando nenhum prompt foi configurado.",
    )
    .nullish(),
}) as unknown as ToZod<TutorAIPromptConfigViewModel>;
